<template>
  <v-menu
    nudge-right="16" nudge-bottom="30" :close-on-content-click="false">
    <template #activator="{on}">
      <div :style="swatchStyle" v-on="on" />
    </template>
    <v-card>
      <v-card-text class="pa-0">
        <v-color-picker
          :value="value" flat
          @input="$emit('input', $event)" />
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import colorConverter from 'color-convert'

export default {
  name: 'BaseColorPicker',
  props: { value: { type: Object, default () { return null } } },
  data () {
    return {
      defaultColor: {
        alpha: 1,
        hex: '#FF0000',
        hexa: '#FF0000FF',
        hsla: { h: 0, s: 1, l: 0.5, a: 1 },
        hsva: { h: 0, s: 1, v: 1, a: 1 },
        hue: 0,
        rgba: { r: 255, g: 0, b: 0, a: 1 },
      },
    }
  },
  computed: {
    swatchStyle () {
      return {
        backgroundColor: this.value?.hexa,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: '25%',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler: function (nVal) {
        if (!nVal) {
          this.$emit('input', this.defaultColor)
        } else if (Object.keys(nVal).length === 1 && nVal.rgba) {
          this.$emit('input', this.createColorObjectFromOnlyRgba(nVal.rgba))
        }
      },
    },
  },
  methods: {
    createColorObjectFromOnlyRgba (rgba) {
      const hex = colorConverter.rgb.hex(rgba.r, rgba.g, rgba.b)
      const hsl = colorConverter.rgb.hsl(rgba.r, rgba.g, rgba.b)
      const hsv = colorConverter.rgb.hsv(rgba.r, rgba.g, rgba.b)
      let hexAlpha = Math.round(rgba.a * 255).toString(16).toUpperCase()
      if (hexAlpha === '0') {
        hexAlpha += '0'
      }
      return {
        alpha: rgba.a,
        rgba: rgba,
        hex: `#${hex}`,
        hexa: `#${hex + hexAlpha}`,
        hsla: { h: hsl[0] / 100, s: hsl[1] / 100, l: hsl[2] / 100, a: rgba.a },
        hsva: { h: hsv[0] / 100, s: hsv[1] / 100, v: hsl[2] / 100, a: rgba.a },
        hue: hsl[0],
      }
    },
  },
}
</script>
